import { useMemo } from 'react';
import { useReactFlow } from 'reactflow';

import { JSONSchema } from '../../json-schema-viewer';

const useParentNodeOutputSchema = (nodeId: string) => {
    const { getNodes, getEdges } = useReactFlow();

    const outputSchema: JSONSchema = useMemo(() => {
        const edges = getEdges();
        const parentEdge = edges.find((edge) => edge.target === nodeId);

        if (parentEdge) {
            const parentNode = getNodes().find((node) => node.id === parentEdge.source);
            return parentNode?.data.outputSchema;
        }

        return {};
    }, [getNodes, getEdges, nodeId]);

    return outputSchema;
};

export default useParentNodeOutputSchema;
